import { render, staticRenderFns } from "./DialogEditor.vue?vue&type=template&id=1cfb6bae&scoped=true&"
import script from "./DialogEditor.vue?vue&type=script&lang=js&"
export * from "./DialogEditor.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditor.vue?vue&type=style&index=0&id=1cfb6bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb6bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VContainer,VFlex,VIcon,VLayout,VSpacer,VTextField,VTooltip})
